import { render } from "./ExerciseOne.vue?vue&type=template&id=512e4f72&scoped=true"
import script from "./ExerciseOne.vue?vue&type=script&lang=js"
export * from "./ExerciseOne.vue?vue&type=script&lang=js"

import "./ExerciseOne.vue?vue&type=style&index=0&id=512e4f72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512e4f72"]])

export default __exports__